import React, { PropsWithChildren } from 'react';
import { Card, CardBody, Button, Badge, Alert } from 'reactstrap';

const QuestionnaireReportComponent = ({
  children,
  onComplete,
  practitionerDisplayName,
  patientDisplayName,
}: PropsWithChildren<{
  onComplete: () => void;
  practitionerDisplayName: string;
  patientDisplayName: string;
}>) => {
  return (
    <Card>
      <CardBody>{children}</CardBody>

      <CardBody>
        <Alert className="lead" color="warning">
          Do you <Badge>{practitionerDisplayName}</Badge> agree that these forms
          accurately record information given in the interview involving{' '}
          <Badge>{patientDisplayName}</Badge>
          <Button className={'float-right'} onClick={onComplete}>
            I agree
          </Button>
        </Alert>
      </CardBody>
    </Card>
  );
};

export default QuestionnaireReportComponent;
